import { Link } from 'react-router-dom'
import Logo from '../components/ui/Logo'
import { SidebarProvider } from '../components/layout/SidebarProvider'
import { ROUTES } from '../constants/routes'
import PropTypes from 'prop-types'

export const StaticPageLayout = ({ children, title }) => (
  <SidebarProvider>
    <div className="min-h-screen bg-dark-primary flex flex-col">
      {/* Fixed Logo Header with Glassmorphism */}
      <div className="sticky top-0 z-20 glassmorphism-header py-6 flex justify-center items-center">
        <Link to={ROUTES.HOME}>
          <Logo size="medium" className="text-white mx-auto" />
        </Link>
      </div>

      <div className="flex-1 flex flex-col items-center px-4 py-12">
        <main className="w-full max-w-4xl">
          <h1 className="text-4xl font-bold text-white mb-8 text-center">{title}</h1>
          {children}
        </main>
      </div>

      <footer className="glassmorphism-footer mt-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex justify-between items-center text-sm text-gray-400">
            <p>&copy; {new Date().getFullYear()} Et Ai Labs. All rights reserved.</p>
            <div className="flex space-x-6">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </SidebarProvider>
)

StaticPageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
}
